<template>
  <div class="mIndex">
    <!-- 全局加载遮罩 -->
    <div v-if="globalLoading" class="global-loading-mask">
      <div class="loading-spinner"></div>
    </div>
    <div class="logoTitle">
      <img src="@/assets/images/jwActivity/logo_title.png" alt="logo" />
    </div>
    <div class="activityTitle">
      <img src="@/assets/images/jwActivity/bg_rank.png" alt="活动标题" />
    </div>
    <div class="date">2026.02.11-03.31</div>
    <div class="joinNum">当前报名人数：{{ joinNum }}人</div>
    <!-- 排行榜表格区域 -->
    <div class="rankTable" style="margin-top: 157px">
      <!-- 表格表头 -->
      <div class="rankTitle">
        <div class="title">名次</div>
        <div class="title">用户邀请码</div>
        <div class="title">分数</div>
      </div>
      <!-- 表格内容：v-for循环索引i作为名次，key唯一 -->
      <div class="rankContent" v-for="(item, index) in rankList" :key="index">
        <div class="rankItem">{{ index + 1 }}</div>
        <div class="rankItem">{{ item.code }}</div>
        <div class="rankItem">{{ item.score }}</div>
      </div>
    </div>

    <div class="rankTable" style="margin-top: 24px">
      <!-- 表格 -->
      <div class="rankTitle">
        <div class="title">我的排名</div>
        <div class="title">分数</div>
      </div>
      <!-- 表格内容：v-for循环索引i作为名次，key唯一 -->
      <div class="rankContent">
        <div class="rankItem">{{ my.code }}</div>
        <div class="rankItem">{{ my.score }}</div>
      </div>
    </div>
    <img class="reward" src="@/assets/images/jwActivity/reward.png" alt />
  </div>
</template>

<script>
export default {
  name: "jwRank",
  data() {
    return {
      globalLoading: false,
      rankList: [],
      my: {},
      joinNum: 0,
    };
  },
  created() {
    this.getAllRankData();
  },
  methods: {
    getAllRankData() {
      this.$loading.show("加载中");
      // 单个请求失败时catch，返回空数据，不影响其他请求
      const getMyPromise = this.$http.post("/svip-api/jianwei/my").catch(() => {
        this.$toast("我的排名加载失败");
        return { data: {} }; // 返回空对象，避免后续解构报错
      });
      const getRankPromise = this.$http
        .post("/svip-api/jianwei/rank")
        .catch(() => {
          this.$toast("榜单排名加载失败");
          return { data: [] }; // 返回空数组，避免后续循环报错
        });

      const getJoinNum = this.$http
        .post("/svip-api/jianwei/person")
        .catch(() => {
          this.$toast("榜单排名加载失败");
          return 0; // 返回空数组，避免后续循环报错
        });

      Promise.all([getMyPromise, getRankPromise, getJoinNum])
        .then(([myRes, rankRes, resJoinNum]) => {
          this.my = myRes.data;
          this.rankList = rankRes.data;
          this.joinNum = resJoinNum.data;
        })
        .finally(() => {
          this.$loading.hide();
        });
    },
    getMy() {
      this.$loading.show("加载中");
      this.$http
        .post("/svip-api/jianwei/my")
        .then((res) => {
          console.log("res", res);
          this.my = res.data;
        })
        .catch((err) => {
          this.$toast(err);
        })
        .finally(() => {
          this.$loading.hide();
        });
    },
    getRank() {
      this.$loading.show("加载中");
      this.$http
        .post("/svip-api/jianwei/rank")
        .then((res) => {
          console.log("res", res);
          this.rankList = res.data;
        })
        .catch((err) => {
          this.$toast(err);
        })
        .finally(() => {
          this.$loading.hide();
        });
    },
  },
};
</script>

<style scoped lang="less">
.mIndex {
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-right: 0 !important;
  overflow-x: hidden;
  overflow-y: auto;
  background-image: url("~@/assets/images/jwActivity/bg_activity.png");
  background-size: 100% 100%;
  position: relative;

  /* 全局加载遮罩 */
  .global-loading-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  .loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #eb698f;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .logoTitle {
    position: absolute;
    left: 28px;
    top: 0px;
    width: 99px;
    height: 18px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  // 重命名避免和外层title类名冲突（原有样式覆盖问题）
  .activityTitle {
    position: absolute;
    transform: translateX(-50%);
    left: 50%;
    top: 43px;
    width: 160px;
    height: 41px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .date {
    position: absolute;
    transform: translateX(-50%);
    left: 50%;
    top: 92px;
    font-weight: 400;
    font-size: 17px;
    color: #543d23;
    line-height: 20px;
    text-align: center; // 改为居中，更符合视觉
    font-style: normal;
    text-transform: none;
  }

  .joinNum {
    position: absolute;
    top: 121px;
    right: 30px;
    width: 100%;
    font-weight: 400;
    font-size: 12px;
    color: #543d23;
    line-height: 17px;
    text-align: right;
    font-style: normal;
    text-transform: none;
  }

  // 排行榜表格容器：核心布局，定位在日期下方，适配移动端
  .rankTable {
    width: 90%;
    //margin-top: 120px; // 避开顶部绝对定位的logo/标题/日期
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #a49079;
  }

  // 表格表头
  .rankTitle {
    display: flex;
    width: 100%;
    background: #533d24; // 浅黄底色，贴合中药/复古活动风格
    border-radius: 6px 6px 0 0;
    .title {
      flex: 1; // 三等分核心属性
      height: 44px;
      line-height: 44px;
      text-align: center;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      box-sizing: border-box;
      border-right: 1px solid #a49079; // 白色分隔线，更清晰
      // 最后一个子元素去掉右边框
      &:last-child {
        border-right: none;
      }
    }
  }

  // 表格行（循环项）
  .rankContent {
    display: flex;
    width: 100%;
    background: #f8f1ea; // 半透明白底，不遮挡背景
    border-bottom: 1px solid #a49079; // 浅分隔线
    // 最后一行去掉下边框
    &:last-child {
      border-bottom: none;
      border-radius: 0 0 6px 6px;
    }
    // 表格单元格
    .rankItem {
      flex: 1; // 三等分核心属性，和表头对齐
      height: 56px;
      line-height: 56px;
      text-align: center;

      font-weight: 400;
      font-size: 20px;
      color: #543d23;

      box-sizing: border-box;
      border-right: 1px solid #a49079;
      // 最后一个单元格去掉右边框
      &:last-child {
        border-right: none;
      }
      // 名次列可单独加样式，比如前3名标色
      //&:first-child {
      //  font-weight: 600;
      //  &:nth-child(1) {
      //    color: #e63946; // 第1名红色
      //  }
      //}
    }
  }

  .reward {
    position: absolute;
    top: 620px;
    left: 50%;
    transform: translateX(-50%);
    //border: 1px solid #EB698F;
    width: 90%;
    margin-bottom: 30px;
  }
}
</style>
